import _isPlainObject from "lodash/isPlainObject";
import { callable } from '@fluentui/styles';
/**
 * Fela plugin for invoking keyframes with params. The keyframes, defined in the animationName prop,
 * are called with the params object, if defined in the animationName prop.
 *
 * Caution! Infinite recursion is possible in case if style object has links to self in the props
 * tree.
 */
export var felaInvokeKeyframesPlugin = function felaInvokeKeyframesPlugin(styles) {
  return Object.keys(styles).reduce(function (acc, cssPropertyName) {
    var cssPropertyValue = styles[cssPropertyName];
    if (_isPlainObject(cssPropertyValue)) {
      if (cssPropertyName === 'animationName') {
        var animationDefinition = cssPropertyValue;
        if (animationDefinition.keyframe) {
          styles[cssPropertyName] = callable(animationDefinition.keyframe)(animationDefinition.params || {});
        }
        acc[cssPropertyName] = styles[cssPropertyName];
        return acc;
      }

      // Without casting to any TSC gives "Expression produces a union type that is too complex to represent" error
      acc[cssPropertyName] = felaInvokeKeyframesPlugin(cssPropertyValue);
      return acc;
    }
    acc[cssPropertyName] = styles[cssPropertyName];
    return acc;
  }, {});
};
//# sourceMappingURL=felaInvokeKeyframesPlugin.js.map
